module.exports = __webpack_public_path__ + "3fd1ff4e37a50e0e9369eca601b402f2.png";